import * as React from "react";
import DeletePanel from "../../components/CustomDelete/DeletePanel";
import strings from "../../config/localization";
import { useDeleteTimeslotMutation } from "../../services/appln";

export default function DeleteTimeslot(props: any): any {
  return (
    <DeletePanel
      useIcon={true}
      deleteMutation={useDeleteTimeslotMutation}
      deleteArgs={{ ...props }}
      buttonLabel={strings.delete}
      confirmationDialogTitle={strings.deleteTimeslotTitle}
      confirmationDialogMsg={strings.deleteTimeslotConfirmation}
      errorDialogTitle={strings.deleteTimeslotFailedTitle}
      errorDialogMsg={strings.deleteTimeslotFailedMsg}
    />
  );
}
